import formatValue from "./formatValue";

export default function getFormattedPercent(valor, base) {
  const percentual = (valor / base) * 100;
  return formatValue(percentual, "percent");
}
